"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Year = /** @class */ (function () {
    function Year(year) {
        this.year = year;
    }
    Object.defineProperty(Year.prototype, "newYearsDay", {
        get: function () {
            return new Date("".concat(this.year, "-01-01"));
        },
        enumerable: false,
        configurable: true
    });
    // find the 3rd Monday in January
    // find the 3rd Monday in February
    // ...etc.
    Year.prototype.monthNthWeekday = function (month, nth, weekday) {
        var firstDay = new Date(this.year, month - 1, 1);
        var weekDay = firstDay.getDay();
        var delta = 0;
        if (weekDay <= weekday) {
            delta = weekday - weekDay;
        }
        else {
            delta = 7 + weekday - weekDay;
        }
        return new Date(Date.UTC(this.year, month - 1, 1 + delta + 7 * (nth - 1)));
    };
    Object.defineProperty(Year.prototype, "martinLutherKingJrDay", {
        get: function () {
            return this.monthNthWeekday(1, 3, 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "washingtonsBirthday", {
        get: function () {
            return this.monthNthWeekday(2, 3, 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "goodFriday", {
        // not a federal holiday
        // but stock market is closed
        // code generated by ChatGPT
        get: function () {
            var a = this.year % 19;
            var b = Math.floor(this.year / 100);
            var c = this.year % 100;
            var d = Math.floor(b / 4);
            var e = b % 4;
            var f = Math.floor((b + 8) / 25);
            var g = Math.floor((b - f + 1) / 3);
            var h = (19 * a + b - d - g + 15) % 30;
            var i = Math.floor(c / 4);
            var k = c % 4;
            var l = (32 + 2 * e + 2 * i - h - k) % 7;
            var m = Math.floor((a + 11 * h + 22 * l) / 451);
            var month = Math.floor((h + l - 7 * m + 114) / 31);
            var day = ((h + l - 7 * m + 114) % 31) + 1;
            var easterSunday = new Date(Date.UTC(this.year, month - 1, day));
            var goodFriday = new Date(easterSunday);
            goodFriday.setDate(easterSunday.getDate() - 2); // Good Friday is 2 days before Easter Sunday
            return goodFriday;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "memorialDay", {
        // last Monday in May
        // should be either 4th or 5th Monday
        get: function () {
            var day = this.monthNthWeekday(5, 5, 1);
            return day > new Date("".concat(this.year, "-05-31")) ? this.monthNthWeekday(5, 4, 1) : day;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "juneteenthNationalIndependenceDay", {
        // since 2021, before 2021 it was not a federal holiday
        get: function () {
            return new Date("".concat(this.year, "-06-19"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "independenceDay", {
        get: function () {
            return new Date("".concat(this.year, "-07-04"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "laborDay", {
        get: function () {
            return this.monthNthWeekday(9, 1, 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "columbusDay", {
        get: function () {
            return this.monthNthWeekday(10, 2, 1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "veteransDay", {
        get: function () {
            return new Date("".concat(this.year, "-11-11"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "thanksgivingDay", {
        get: function () {
            return this.monthNthWeekday(11, 4, 4);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Year.prototype, "christmasDay", {
        get: function () {
            return new Date("".concat(this.year, "-12-25"));
        },
        enumerable: false,
        configurable: true
    });
    return Year;
}());
exports.default = Year;
